import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importation des fichiers JSON
import ar from './i18n/locales/ar.json';
import en from './i18n/locales/en.json';
import es from './i18n/locales/es.json';
import fr from './i18n/locales/fr.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
    },
    lng: 'fr', // Langue par défaut
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // React protège déjà contre les injections XSS
    },
    react: {
      useSuspense: false // Évite les erreurs de chargement asynchrone
    }
  });

export default i18n;    